export default "__VITE_ASSET__BxUqCRze__"